import CopyIcon from 'components/icons/CopyIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import EditIcon from 'components/icons/EditPenIcon.js'
import React from 'react'
import {
  Container,
  ContentWrapper,
  Date1,
  Date2,
  Duration,
  HorizontalLine,
  Icon,
  IconsWrapper,
  Location,
  MainDiv,
  Regenddate,
  StyledText,
  StyledText1,
  StyledText2,
  TimeDiv,
  VerticalDivider,
  VerticalDivider1,
} from './style'

const EventDraft = () => {
  const MainDivComponent = ({
    variant,
    styledText,
    styledText1,
    styledText2,
    regenddate,
    icon1,
    icon2,
    icon3,
    date,
    showDivider1,
    showDivider2,
  }) => {
    return (
      <MainDiv variant={variant} width="100%">
        <ContentWrapper>
          <StyledText>{styledText}</StyledText>
          <VerticalDivider show={showDivider1} />
          <StyledText1>
            {styledText1} <StyledText2>{styledText2}</StyledText2>
          </StyledText1>

          <VerticalDivider show={showDivider2} />
          <Regenddate>{regenddate}</Regenddate>
          <Date2>{date}</Date2>
        </ContentWrapper>
        <IconsWrapper>
          <Icon>{icon1}</Icon>
          <Icon>{icon2}</Icon>
          <Icon>{icon3}</Icon>
        </IconsWrapper>
      </MainDiv>
    )
  }
  const TimeDivComponent = ({
    variant,
    duration,
    styledText1,
    styledText2,
    icon1,
    icon2,
    icon3,
    date,
    showDivider1,
    showDivider2,
    location,
  }) => {
    return (
      <TimeDiv variant={variant} width="100%">
        <ContentWrapper>
          <Duration>{duration}</Duration>
          <VerticalDivider1 show={showDivider1} />
          <div style={{ display: 'flex' }}>
            <StyledText1>
              {styledText1}
              <StyledText2>{styledText2}</StyledText2>
            </StyledText1>
          </div>

          <VerticalDivider1 show={showDivider2} />
          <Location>{location}</Location>
          <Date1>{date}</Date1>
        </ContentWrapper>
        <IconsWrapper>
          <Icon>{icon1}</Icon>
          <Icon>{icon2}</Icon>
          <Icon>{icon3}</Icon>
        </IconsWrapper>
      </TimeDiv>
    )
  }
  return (
    <>
      <Container>
        <div>
          <MainDivComponent
            variant="default"
            styledText="All day"
            styledText1="College day"
            styledText2="(Activity/Event)"
            icon1={<DeleteIcon />}
            icon2={<EditIcon />}
            icon3={<CopyIcon />}
            showDivider1={true}
            showDivider2={false}
          />
        </div>
      </Container>
      <Container>
        <div>
          <MainDivComponent
            variant="default"
            styledText="All day"
            styledText1="Holi celebrations"
            styledText2="(Activity/Event)"
            icon1={<DeleteIcon />}
            icon2={<EditIcon />}
            icon3={<CopyIcon />}
            showDivider1={true}
            showDivider2={false}
          />
        </div>
      </Container>

      <Container>
        <div>
          <MainDivComponent
            variant="default"
            styledText="All day"
            styledText1="Startup Mastery "
            styledText2=" (Conference)"
            regenddate="Registration end date"
            date="23rd Feb 2024"
            icon1={
              <DeleteIcon style={{ marginLeft: '2px', marginTop: '8px' }} />
            }
            icon2={<EditIcon />}
            icon3={<CopyIcon />}
            showDivider1={true}
            showDivider2={true}
          />
        </div>
      </Container>

      <HorizontalLine />
      <Container>
        <div>
          <TimeDivComponent
            variant="default"
            duration="-"
            styledText1="Seminar Name "
            styledText2=" (Seminar)"
            // location="Event Location"
            // date="College Seminar Hall"
            icon1={<DeleteIcon />}
            icon2={<EditIcon />}
            icon3={<CopyIcon />}
            showDivider1={true}
            showDivider2={false}
          />
        </div>
      </Container>
      <Container>
        <div>
          <TimeDivComponent
            variant="default"
            duration="-"
            styledText1="Exhibition Name "
            styledText2=" (Exhibition)"
            // location="Event Location"
            // date="College Ground"
            icon1={<DeleteIcon />}
            icon2={<EditIcon />}
            icon3={<CopyIcon />}
            showDivider1={true}
            showDivider2={false}
          />
        </div>
      </Container>
    </>
  )
}
export default EventDraft
